import Vue from 'vue';
import DnDSource from './DnDSource.vue';
import DnDTarget from './DnDTarget.vue';
import { IDnDData } from './IDnDData';

export function registerDnD() {
    Vue.component('DnDSource', DnDSource);
    Vue.component('DnDTarget', DnDTarget);
}

export {
    DnDSource,
    DnDTarget,
    IDnDData,
};
